import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// Import action creators
import { getAllProducts, getDiscountCode, validateAndApplyDiscount } from '../actions';
import { addToCart, checkout, removeFromCart, removeAllFromCart } from '../actions';
// Import selectors for totals and cart products
import {
    getTotalCartAfterProductDiscount,
    getCartProducts,
    getTotalFullPrice,
    getTotalCartWithDiscountCode
} from '../reducers';
import Cart from '../pages/shop/cart/Cart';

// CartContainer now expects verbose prop names for totals.
const CartContainer = ({
                           products,
                           discount,
                           code,
                           totalAmountCartWithDiscountAndDiscountCode,
                           totalAmountCartWithoutDiscount,
                           totalAmountCartWithProductDiscount,
                           getAllProducts,
                           checkout,
                           addToCart,
                           removeFromCart,
                           removeAllFromCart,
                           validateAndApplyDiscount,
                           getDiscountCode
                       }) => {
    useEffect(() => {
        // Dispatch the getAllProducts action when the component mounts
        getAllProducts();
    }, [getAllProducts]);

    // If products or final total are not available, show a loading indicator.
    if (!products) {
        return <div>Loading...</div>;
    }

    if (products.length === 0) {
        return (
            <div
                className="font-tiskani"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '80vh',
                    textAlign: 'center',
                    padding: '2rem'
                }}
            >
                <p>Košarica je prazna.</p>
            </div>
        );
    }


    return (
        <Cart
            // Pass the list of cart products.
            products={products}
            // Final total after applying both product-level discount and discount code.
            totalAmountCartWithDiscountAndDiscountCode={totalAmountCartWithDiscountAndDiscountCode}
            // Full cart price without any discounts.
            totalAmountCartWithoutDiscount={totalAmountCartWithoutDiscount}
            // Total after applying only product-level discounts (before discount code).
            totalAmountCartWithProductDiscount={totalAmountCartWithProductDiscount}
            // Pass discount percentage and discount code from cart state.
            discount={discount}
            code={code}
            // Pass action creators as callbacks.
            getAllProducts={getAllProducts}
            onCheckout={(form) => checkout(form)}
            onIncrement={(productId) => addToCart(productId)}
            onDecrement={(productId) => removeFromCart(productId)}
            onDeleteAll={(productId) => removeAllFromCart(productId)}
            onDiscountCode={(discountCode) => validateAndApplyDiscount(discountCode)}
            getDiscountCode={(discountCode) => getDiscountCode(discountCode)}
        />
    );
};

CartContainer.propTypes = {
    // List of cart products
    products: PropTypes.arrayOf(PropTypes.shape({
        productId: PropTypes.number.isRequired,
        productName: PropTypes.string.isRequired,
        brandName: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        specialPrice: PropTypes.number.isRequired,
        discount: PropTypes.number.isRequired,
        quantity: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired
    })),
    // Verbose totals
    totalAmountCartWithDiscountAndDiscountCode: PropTypes.string,
    totalAmountCartWithoutDiscount: PropTypes.string,
    totalAmountCartWithProductDiscount: PropTypes.string,
    discount: PropTypes.string,
    code: PropTypes.string,
    // Action creators
    getAllProducts: PropTypes.func.isRequired,
    checkout: PropTypes.func.isRequired,
    addToCart: PropTypes.func.isRequired,
    removeFromCart: PropTypes.func.isRequired,
    removeAllFromCart: PropTypes.func.isRequired,
    validateAndApplyDiscount: PropTypes.func.isRequired,
    getDiscountCode: PropTypes.func.isRequired,
};

// Map state to props using verbose names.
const mapStateToProps = (state) => ({
    // List of cart products
    products: getCartProducts(state),
    // Final total after both product-level and discount-code discounts applied.
    totalAmountCartWithDiscountAndDiscountCode: getTotalCartWithDiscountCode(state),
    // Full price of cart without any discounts.
    totalAmountCartWithoutDiscount: getTotalFullPrice(state),
    // Total after applying only product-level discounts.
    totalAmountCartWithProductDiscount: getTotalCartAfterProductDiscount(state),
    // Discount percentage from cart state.
    discount: state.cart.discount,
    // Discount code from cart state.
    code: state.cart.code
});

const mapDispatchToProps = {
    getAllProducts,
    checkout,
    addToCart,
    removeFromCart,
    removeAllFromCart,
    validateAndApplyDiscount,
    getDiscountCode
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CartContainer);
